import { Component, Input, OnInit } from '@angular/core';
import {
  REGISTRATION_STEP_ORDER,
  RegistrationFlowStep,
  RegistrationFlowStepId,
} from 'src/app/constants/registration-flow.constants';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';
import { RegistrationFlowService } from 'src/app/services/registration-flow/registration-flow.service';

@Component({
  selector: 'app-progress-stepper',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss'
})

export class ProgressBarComponent implements OnInit {

  @Input() public currentStep: RegistrationFlowStepId;
  @Input() public label: string = '';
  @Input() public icon: string = '/assets/images/icons/warning.svg';

  // represents steps in the registraton flow
  public segments: boolean[] = [];

  constructor(
    private registrationFlowService: RegistrationFlowService,
    private featureFlagService: FeatureFlagsService,
  ) {}

  ngOnInit(): void {
    this.buildSegments();
    // The steps arrive asynchronously, recompute once they are available
    this.registrationFlowService.loadSteps().subscribe(() => this.buildSegments());
  }

  /**
   * Derives the segments from the user's actual flow,
   * falling back to the full step list until
   * GET /api/registration/me/steps resolves.
   */
  private buildSegments(): void {
    const steps = this.registrationFlowService.getSteps() ?? REGISTRATION_STEP_ORDER;
    const visibleSteps = steps.filter((step) => this.isStepVisible(step));
    const currentIndex = visibleSteps.indexOf(this.currentStep);

    this.segments = visibleSteps.map((_, index) => index <= currentIndex); // _ is the step id, unused param
  }

  private isStepVisible(step: string): boolean {
    if (step === RegistrationFlowStep.Dashboard) {
      return false;
    }
    if (step === RegistrationFlowStep.WelcomeGift) {
      return this.featureFlagService.isEnabled('isPetPlanFreeInsuranceStep4Available');
    }
    return true;
  }
}
